import React from "react";
import { useTranslation } from '../hooks/useTranslation';

export const Header = () => {

    const { translate } = useTranslation();
  

  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1 className="responsive-h1">
                  {translate('header_title')}
                  <span></span>
                </h1>
                <p>{translate('header_paragraph')}</p>
                <a
                  href="#features"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  {translate('learn_more')}
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
